import React from 'react';
import ReactDOMServer from 'react-dom/server';
import { Navigate } from "react-router-dom";
import moment from 'moment';
import '../../css/ticket.css';
const common = require('../common/common.jsx');
const ticketCommon = require('../common/ticketCommon.jsx');
const env = require("../../config.js").default;

try {
    require("moment/locale/" + common.getLanguageMoment() + ".js");
} catch (err) {
    require("moment/locale/en-gb.js");
}

class TicketTableFirebird extends React.Component {
    constructor(props) {
        super(props);
        this.state={}
        this.state.pathname = this.props.pathname;
        this.state.recordTabella = {};
        this.state.items = [];
        this.state.NTELA = this.props.NTELA ? this.props.NTELA : ''
        this.state.items_total = {}
        this.state.userInfo = {};
        this.state.userInfo.roles = [];
        this.changePage = this.changePage.bind(this);
        this.state.userInfo.userInfo = {};
        this.state.customTag = <></>;
        this.state.stati_ticket = []
        this.state.folder = this.props.folder
        this.state.cfold = (window.location.href.includes('reclami-consegna') === true ? 'deliveryClaims' : 'ticket')
        this.state.pagination = {
            actualPage: parseInt(common.getParam("page", "", 1)) - 1,
            prev: false,
            next: false,
        }
        if (this.state.pagination.actualPage > 1)
            this.state.pagination.prev = true;
        this.state.paginazioneCustomButtons = [];
        this._isMounted = false;
        this.state.is_multibrand = this.props.is_multibrand;
        this.state.is_admin = this.props.is_admin;
        //this.state.dates = this.props.dates
        this.state.mostraNazione = this.props.mostraNazione
        this.state.marcaDefault = common.get_localStorage("valoreMarca") !== undefined ?
            common.get_localStorage("valoreMarca")
            : this.props.marche_attive !== undefined && this.props.marche_attive.length > 1 && this.state.is_multibrand === false ?
                this.props.marcaDefault
                :
                this.props.marche_attive[0].ZFORN;

        this.userInfoPromise = common.getUserInfo().then(userInfo => {
            this.setState({ userInfo: userInfo });
            return userInfo;
        })
        this.state.tickets_number = 0
        this.state.items_showed = 0
        this.state.start = 0
        this.state.length = 0
        this.TicketTableFirebirdDrawCallback = this.TicketTableFirebirdDrawCallback.bind(this);
    }



    componentDidMount(props) {
        const $ = window.$;
        this._isMounted = true;
        $(document).ready(function () {
            $(window).resize(function () {
                window.setTimeout(function () {
                    if ($('#tickets_firebird_table').is(":visible"))
                        $('#tickets_firebird_table').DataTable()?.columns?.adjust();
                }, 600);
            });
        });

        var apiUrl = common.getTicketBackendUrl(this.state.pathname);
        var isTicketvehicle = false
        if (this.props.ticketType === 'ticket_vehicle') {
            isTicketvehicle = true
        }
        
        var is_admin = true
        if (this.props.is_admin === false) {
            is_admin = false
        }

        const caColPosition = [
            "caCAVTL",
            "caNTELA",
            "caDDOCU",
            "caCAVTI",
            "caRUSER",
            "caCNAZI",
            "caNEW12",
            "caZFORN",
            "caDCAUS",
            "caCSCAU",
            "caUINSR",
            "caULUPD",
            "caURICH",
            "caRADMI",
        ];

        const BATCHING_SIZE = 25;
        
        function get_row_counter(message) {
            let el = document.querySelector('#tickets_firebird_table_paginate');
            let div = document.createElement('div');
            div.textContent = message;
            el.before(div);
        }
        Promise.all([
            common.get_UX_page(this.state.folder),
            this.userInfoPromise
        ]).then(([dataDB, userInfo]) => {
            if (dataDB['result'] !== undefined){
                if (dataDB['result']['Table'] !== undefined){
                    if (dataDB['result']['Table']["OrderSettings"] !== undefined){
                        var dictOrder = []
                        dataDB['result']['Table']["OrderSettings"].forEach(subArray => {
                            dictOrder.push([caColPosition.indexOf("ca" + subArray[0]), subArray[1]])
                        });
                    }
                }
            }
            if (dataDB['result'] !== undefined){
                this.getCountTicketFirebird(dataDB['result'])
            }else{
                this.getCountTicketFirebird()
            }
            const isEptaTicketAdmin =
                userInfo.is_admin_ticket === true && window.cc.csoft === 850034;
            const defaultOrderCol = isEptaTicketAdmin ? "caURICH" : "caULUPD";
            const defaultOrder2 = isEptaTicketAdmin ? "asc" : "desc";
            $('#tickets_firebird_table').DataTable({
                "retrieve": true,
                "responsive": false,
                "lengthChange": false,
                "width": "100%",
                "scrollX": true,
                "autoWidth": true,
                "sScrollX": "100%",
                "sScrollXInner": "100%",
                "pageLength": BATCHING_SIZE,
                "displayStart": this.state.pagination.actualPage * BATCHING_SIZE,
                "pagingType": "simple",
                "dom": "lfrti",
                "buttons": false,
                "filter": true,
                "processing": true,
                "ordering": true,
                "order": dataDB['result'] !== undefined && dataDB['result']['Table'] !== undefined ? dataDB['result']['Table']["OrderSettings"] !== undefined ? dictOrder : [[caColPosition.indexOf(defaultOrderCol), defaultOrder2]] : [[caColPosition.indexOf(defaultOrderCol), defaultOrder2]],
                "searching": true,
                "search": {
                    "search": dataDB['result'] !== undefined && dataDB['result']['Table'] !== undefined && this.props.innerTable === false ? dataDB['result']['Table']['SearchValue'] !== undefined ? dataDB['result']['Table']['SearchValue'] : '' : ''
                },
                "info": false,
                serverSide: true,
                ajax: {
                    url: apiUrl,
                    type: 'GET',
                    data: (data) => {
                        var table = $("#tickets_firebird_table").DataTable();
                        $("#tickets_firebird_table_filter input").unbind()
                        var folder = window.location.href.includes('reclami-consegna') === true ? 'reclami-consegna' : 'ticket'
                        $("#tickets_firebird_table_filter input").bind('input', (delay( (e) => {
                            table.search($("#tickets_firebird_table_filter input").val()).draw();
                            var value = $("#tickets_firebird_table_filter input").val()
                            if(this.props.innerTable === false){
                                common.add_UX_data(folder, "Table", "SearchValue", $("#tickets_firebird_table_filter input").val())
                            }
                            let pagination = this.state.pagination;
                            pagination.actualPage = 0
                            this.setState({pagination : pagination})
                            this.tablePageChange(0)
                            ticketCommon.addDot(value, $('#tickets_firebird_table_filter > label'))
                            this.getCountTicketFirebird(null, value)
                            return;
                        }, 1000)))
    
                        
                        var orderDbIndex = []
                        var orderSettings = $('#tickets_firebird_table').DataTable().order();
                        var order = "";
                        for (var i = 0; i < orderSettings.length; i++) {
                            if (order !== "")
                            order = order + ",";
                            var orderColumn = $('#tickets_firebird_table').DataTable().column(orderSettings[i][0]).dataSrc();
                            order = order + "{{" + orderColumn + "}} " + orderSettings[i][1].toUpperCase();
                            var appo = []
                            appo.push(orderColumn)
                            appo.push(orderSettings[i][1])
                            orderDbIndex.push(appo)
                        }

                        data.OrderPage = order
                        //common.add_UX_data(this.state.folder, "Table", "OrderSettings", orderDbIndex)

                        this.getDataforFilters(data)

                        if(this.state.NTELA !== undefined && this.state.NTELA !== ''){
                            data.NTELA = this.state.NTELA
                        }
                    },
                    dataSrc: (json) => {
                        var table = $("#tickets_firebird_table").DataTable();
                        $("#tickets_firebird_table_last").hide();
                        var orderDbIndex = []
                        var orderSettings = $('#tickets_firebird_table').DataTable().order();
                        var order = "";
                        for (var i = 0; i < orderSettings.length; i++) {
                            if (order !== "")
                                order = order + ",";
                            var orderColumn = $('#tickets_firebird_table').DataTable().column(orderSettings[i][0]).dataSrc();
                            order = order + "{{" + orderColumn + "}} " + orderSettings[i][1].toUpperCase();
                            var appo = []
                            appo.push(orderColumn)
                            appo.push(orderSettings[i][1])
                            orderDbIndex.push(appo)
                        }
                        var folder = window.location.href.includes('reclami-consegna') === true ? 'reclami-consegna' : 'ticket'
                        table.on('order', function () {
                            common.add_UX_data(folder, "Table", "OrderSettings", orderDbIndex)
                        })
                        let pagination = this.state.pagination;
                        if (table.page.len() > json.data.length) {
                            this.state.pagination.next = false;
                        } else {
                            this.state.pagination.next = true;
                        }
                        pagination.prev = (table.page.info()["page"] > 0);
                        this.setState({ pagination: pagination });
                        return json.data;
                    },
                },
    
                columns: [
                    {
                        data: "CAVTL",
                        "class": "never",
                        "render": (data, type, row) => {
                            if (row.CAVTL !== undefined && row.CAVTL === '00')
                                return "0"
                            else
                                return "1";
                        },
                        "visible": false,
                    },
                    {
                        title: common.getTrad("Telaio"),
                        data: "NTELA",
                        width: "10px",
                        visible: isTicketvehicle,
                        "targets": caColPosition.indexOf("caNTELA"),
                        "class": 'vin_vehicle sorting',
                        "render": (data, type, row) => {
                            if (row.NTELA) {
                                return `<span class="fastCopy" data-value="${row.NTELA}"><i class="far fa-copy"></i>&nbsp;&nbsp;${row.NTELA}</span>`;
                            } else {
                                return "";
                            }
                        }
                    },
                    {
                        title: common.getTrad("Titolo"),
                        data: "DDOCU",
                        "width": "30px",
                        "class": 'sortable_title sorting',
                        "targets": caColPosition.indexOf("caDDOCU"),
                        "render": (data, type, row) => {
                            var ret = '';
                            if (row.DDOCU.length > 45) {
                                ret = <>{common.truncateOnWord(row.DDOCU, 45)}</>;
                            } else {
                                ret = <>{row.DDOCU}</>;
                            }
    
                            return ReactDOMServer.renderToStaticMarkup(
                                <>
                                    <small className="datatableSmall">{row.ID}</small>
                                    {ret}
                                </>
                            )
                        }
                    },
                    {
                        title: common.getTrad("Stato"),
                        data: "CAVTI",
                        width: "10px",
                        "class": 'review_state sorting',
                        "targets": caColPosition.indexOf("caCAVTI"),
                        "render": function (data, type, row) {
                            if (row.CAVTI.indexOf("90") > -1) {
                                return "<span class=\"closed\" style=\"font-weight:normal;background: #dc3545;box-shadow:1px 1px 3px -1px #000;padding: 0.25em 0.5em;color: #fff;\" title=\"" + common.getTrad("Chiuso") + (row.UCLOS ? " " + moment(row.UCLOS).format('LLL') : '') + "\"><i class=\"fas fa-envelope\"></i></span>";
                            } else if (row.CAVTI.indexOf("11") > -1) {
                                return "<span style=\"font-weight:normal;background: #ffc107;box-shadow:1px 1px 3px -1px #000; padding: 0.25em 0.5em;color: #000;\" title=\"" + common.getTrad("Incompleto") + "\"><i class=\"fas fa-envelope-open\"></i></span>";
                            } else if (row.CAVTI.indexOf("70") > -1) {
                                return "<span style=\"font-weight:normal;background: #007bff;box-shadow:1px 1px 3px -1px #000; padding: 0.25em 0.5em;color: #fff;\" title=\"" + common.getTrad("In lavorazione") + "\"><i class=\"far fa-envelope-open\"></i></span>";
                            } else if (row.CAVTI.indexOf("00") > -1) {
                                return "<span style=\"font-weight:normal;background: #ffc107;box-shadow:1px 1px 3px -1px #000; padding: 0.25em 0.5em;color: #000;\" title=\"" + common.getTrad("Bozza") + "\"><i class=\"far fa-envelope-open\"></i></span>";
                            } else if (row.CAVTI.indexOf("75") > -1) {
                                return "<span style=\"font-weight:normal;background: #6c757d;box-shadow:1px 1px 3px -1px #000; padding: 0.25em 0.5em;color: #fff;\" title=\"" + common.getTrad("Lavorazione interna") + "\"><i class=\"far fa-envelope-open\"></i></span>";
                            } else if (row.CAVTI.indexOf("80") > -1) {
                                return "<span style=\"font-weight:normal;background: #17a2b8;box-shadow:1px 1px 3px -1px #000; padding: 0.25em 0.5em;color: #fff;\" title=\"" + common.getTrad("Lavorazione terminata") + "\"><i class=\"far fa-envelope\"></i></span>";
                            } else {
                                return "<span style=\"font-weight:normal;background: #28a745;box-shadow:1px 1px 3px -1px #000; padding: 0.25em 0.5em;color: #fff;\" title=\"" + common.getTrad("Aperto") + "\"><i class=\"fas fa-envelope-open-text\"></i></span>";
                            }
                        }
                    },
                    {
                        title: common.getTrad("Pubblicato da"),
                        data: 'RUSER',
                        width: "30px",
                        visible: is_admin,
                        "class": "Creator sorting ticket_creator",
                        "targets": caColPosition.indexOf("caRUSER"),
                        "render": (data, type, row) => {
                            var ret = '';
                            if (data.length > 30) {
                                ret = <span alt={data} title={data}>{common.truncateOnWord(row.RUSER, 30)}</span>;
                            } else {
                                ret = <>{data}</>;
                            }
    
                            return ReactDOMServer.renderToStaticMarkup(
                                <>
                                    {ret}
                                </>
                            )
                        }
                    },
                    {
                        title: common.getTrad("Nazione"),
                        width: "10px",
                        "class": "user_cnazi sorting",
                        "targets": caColPosition.indexOf("caCNAZI"),
                        visible: is_admin,
                        data: "CNAZI",
                        "render": (data, type, row) => {
                            return row.CNAZI !== undefined && row.DNAZI !== undefined && row.CNAZI !== null && row.DNAZI !== null ?  row.DNAZI : "";
                        }
                    },
                    {
                        data: 'CAVTI',
                        "visible": false,
                    },
                    {
                        title: common.getTrad("Marca"),
                        visible: this.state.is_multibrand,
                        data: "ZFORN",
                        width: "90px",
                        "targets": caColPosition.indexOf("caZFORN"),
                        "render": (data, type, row) => {
                            var brand = row.ZFORN
                            if (brand === undefined || brand.length === null)
                                brand = this.state.marcaDefault;
    
                            if (type !== "display")
                                return brand;
    
                            var indexBrand = common.object_value_in_array(window.cc.marche_portale, 'ZFORN', brand);
                            if (window.cc.marche_portale !== undefined && window.cc.marche_portale[indexBrand] !== undefined) {
                                let text = window.cc.marche_portale[indexBrand].DFORN
                                return '<img class="tableBrandImg" title="' + text + '" alt="' + text + '" src="' + env.SWAN + 'static/images/loghi/' + brand.toLowerCase() + '.png"/>';
                            }
                            else
                                return brand;
                        }
                    },
                    {
                        title: common.getTrad("Tipo"),
                        data: "DCAUS",
                        "targets": caColPosition.indexOf("caDCAUS"),
                        width: "10px",
                        "render": (data, type, row) => {
    
                            if (row.DCAUS !== null && row.DCAUS !== undefined)
                                return common.truncateOnWord(row.DCAUS, 30)
                            else
                                return ""
                        }
                    },
                    {
                        title: common.getTrad("Sotto Tipo"),
                        data: "CSCAU",
                        "targets": caColPosition.indexOf("caCSCAU"),
                        visible: this.state.marcaDefault === 'EA' && this.state.cfold === 'ticket',
                        width: "10px",
                        "render": (data, type, row) => {
                            if (row.CSCAU !== null && row.CSCAU !== undefined && row.CSCAU !== "")
                                return getSubTypeName(row.CSCAU, 30)
                            else
                                return ""
                        }
                    },
                    {
                        title: common.getTrad("Data Ins."),
                        width: "10px",
                        data: "UINSR",
                        "targets": caColPosition.indexOf("caUINSR"),
                        "class": 'created sorting',
                        type: 'datetime-moment',
                        "render": function (data, type, row) {
                            return moment(row.UTRAS ? row.UTRAS : row.UINSR).format('L') + "\n" + '<small class=\"datatableSmall\">' + moment(row.UTRAS ? row.UTRAS : row.UINSR).format('LT') + '</small>';
                        }
                    },
                    {
                        title: common.getTrad("Data Mod."),
                        "data": 'ULUPD',
                        width: "10px",
                        type: 'datetime-moment',
                        "targets": caColPosition.indexOf("caULUPD"),
                        "class": 'modified sorting',
                        "render": function (data, type, row) {
                            return moment(row.ULUPD).format('L') + "\n" + '<small class=\"datatableSmall\">' + moment(row.ULUPD).format('LT') + '</small>';
                        }
                    },
                    {
                        title: common.getTrad("Data Richiesta"),
                        "data": 'URICH',
                        width: "10px",
                        type: 'datetime-moment',
                        visible: isEptaTicketAdmin,
                        "targets": caColPosition.indexOf("caURICH"),
                        "class": 'modified sorting',
                        "render": function (data, type, row) {
                            return row.URICH ? moment(row.URICH).format('L') + "\n" + '<small class=\"datatableSmall\">' + moment(row.URICH).format('LT') + '</small>' : '';
                        }
                    },
                    {
                        title: "<span><i class='fa fa-user-shield' style= text-align: 'center'></i></span>", 
                        width: "10px",
                        data: "RADMI",
                        visible: is_admin,
                        "class": "ticket_creator text-right",
                        "targets": caColPosition.indexOf("caRADMI"),
                        "render": (data, type, row) => {
                            var ret = '';
                            if(data !== null){
                                ret = <span class={"circleAdmin"} style={{ background: row.CCOLO}} alt={data} title={data}>{common.createInitial(row.RADMI)}</span>;
                                return ReactDOMServer.renderToStaticMarkup(
                                    <>
                                        {ret}
                                    </>
                                )
                            }else{
                                return ReactDOMServer.renderToStaticMarkup(
                                    <>
                                        {ret}
                                    </>   
                                )                             
                            }
                        }
                    }
                ],
                "createdRow": (row, data) => {
                    $(row).find('.fastCopy').on('click', function (e) {
                        e.stopPropagation()
                        fastCopy(e, $(this));
                    });
                },
                "language": {
                    "url": env.STATIC + "lib/datatables/i18n/" + common.getLanguage() + ".lang"
                }, 
                "initComplete": function (settings, json) {
                    $("#ticketCounter").prependTo("#tickets_firebird_table_filter")
                    $("#ticketCounter").removeAttr('hidden')           
                    if (dataDB['result']){
                        if (dataDB['result']['Table']){
                            if (dataDB['result']['Table']['SearchValue'] !== undefined && this.props?.innerTable === false){
                                ticketCommon.addDot(dataDB['result']['Table']['SearchValue'], $('#tickets_firebird_table_filter > label'))
                            }
                        }
                    }
                },               
                fnRowCallback: (nRow, aData, iDisplayIndex, iDisplayIndexFull) => {
    
                    // Row click
                    $(nRow).on('click', (e) => {
                        if($(e.target).hasClass('fastCopy')) return false;
                        if ($("#tickets_firebird_table").hasClass("collapsed")) {
                            if (e.currentTarget.classList[1] === "parent" && e.target.cellIndex > 0) {
                                this.changePage(common.getFirebirdUrl(String(aData["ID"])));
                                return false;
                            }
                            if (e.target.cellIndex === undefined || e.target.cellIndex > 0) {
                                this.changePage(common.getFirebirdUrl(String(aData["ID"])));
                                return false;
                            }
                        }
                        else if ($("#pills-ticket").hasClass("innerTable")){
                            this.changePage(common.getFirebirdUrl(String(aData["ID"]), true));
                        } else {
                            this.changePage(common.getFirebirdUrl(String(aData["ID"])));
                            return false;
                        }
                    })
    
                    if ((aData['CAVTL'] === '10' && this.state.userInfo.is_admin_ticket === false) || (aData['CAVTL'] === '20' && this.state.userInfo.is_admin_ticket === true))
                        $(nRow).addClass('font-weight-bold');

                },
                "drawCallback": this.TicketTableFirebirdDrawCallback
            })
        })
        if (common.get_localStorage("sortOrderColumnTicket") !== undefined && common.get_localStorage("sortOrderColumnTicket"))
            this.props.paginaDati.verso_ordinamento = parseInt(common.get_localStorage("sortOrderColumnTicket"))
        
    }

    TicketTableFirebirdDrawCallback(settings) {
        var $ = window.$;
        var $container = $("#tickets_firebird_table_wrapper .dataTables_scrollHead").parent();
        var $scroller = $("#tickets_firebird_table_wrapper .dataTables_scrollBody");
        common.bindDragScroll($container, $scroller);
        // Use the DataTable API to get the required data in a safe way
        try {
            var table = $("#tickets_firebird_table").DataTable();
            var items_showed = table.data().length;
            var info = (typeof table.page === 'function') ? table.page.info() : null;
            var startIdx = (info && typeof info.start === 'number') ? info.start : 0;
            var length = startIdx + items_showed;
            this.setState({
                items_showed: items_showed,
                start: startIdx + 1,
                length: length
            });
        } catch (err) {
            console.debug('TicketTableFirebirdDrawCallback: unable to read table info', err);
        }
    }
    
    componentDidUpdate(nextProps) {
        const $ = window.$;
        let pagination = this.state.pagination;
        if (this.props.resetpagination === true) {
            pagination.actualPage = 0
            this.props.sendData(false);
        }
        if (this.props !== nextProps) {
            this.setState({ is_multibrand: nextProps.is_multibrand, is_admin : nextProps.is_admin });
        }


        if (this.state.userInfo.is_admin_ticket !== undefined && !this.state.userInfo.is_admin_ticket) {
            $("body").append('<style>.ticket_creator{display:none}</style>');
            $("body").append('<style>.user_cnazi{display:none}</style>');
        }

        $("#filtra_tickets").unbind().on('click', (e) =>{
            common.get_UX_component(this.state.folder, "Table", "SearchValue").then((value) => {
            if(value !== undefined){
                this.getCountTicketFirebird(null, value)
            }else{
                this.getCountTicketFirebird()
            }
            })
        })
    }

    changePage(id) {
        this._isMounted && this.setState({
            customTag: (<Navigate to={id} push={true} />)
        })
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    exportData = (e) => {
        const $ = window.$;
        $("#dropdownExport").attr("disabled", true);
        $("#dropdownExport i").removeClass("far fa-file-excel")
        $("#dropdownExport i").addClass("fa fa-spinner fa-spin")
        var exportType = e.target.getAttribute('data-arg1');
        var campi = ['ID', 'DDOCU', 'URICH', 'DNAZI', 'ULUPD', 'CAVTI', 'RUSER', 'CCORR', 'RADMI', 'DCAUS', 'UFSPC', 'UINSR'];
        if (window.cc.csoft === 850034 && this.state.cfold === 'ticket'){
            campi.push('CSCAU')
        }

        if(exportType === 'complete'){
            campi.push('BDOCU');
        }

        if (this.props.ticketType === 'ticket_vehicle' && exportType !== 'complete'){
            campi.push('NTELA');
        }
        if(this.state.is_multibrand){
            campi.push('ZFORN');
        }
        var searchExport = $("#tickets_firebird_table_filter input").val()
        var selectedStates = this.props.selectedStates;
        var stati = [];
        for (var i = 0; i < selectedStates.length; i++) {
            var single = selectedStates[i];
            stati.push(ticketCommon.codifica_stati(single));
        };

        var yearToFilter = this.props.selectedDates['year']
        // For epta, if state contains the closed status, the year filter is mandatory, so preselect current year
        if (window.cc.csoft === 850034 && $('#yearSelect').is(':visible') && stati.includes(ticketCommon.codifica_stati('closed')) && !yearToFilter) {
            yearToFilter = String(new Date().getFullYear());
            // Set the year in the date filter UI if it's not already set
            if (!window.$('#yearSelect').val()) {
                window.$('#yearSelect').val(yearToFilter).trigger('change');
            }
        }

        if (this.state.cfold === 'ticket') {
            var tipologia = this.props.selectedType;
            var sottoTipo = this.props.selectedSubType
            var params = {
                'export': 1,
                'admin': this.props.selectedAdmins,
                'nazione': this.props.selectedNations,
                'statiCodificati': stati,
                'tipologia': tipologia,
                'year': yearToFilter,
                'month': this.props.selectedDates['month'],
                'subType': sottoTipo,
                'VM': this.props.selectedVM ? this.props.selectedVM : null,
                'campiExport': campi,
                'searchExport' : searchExport
            };
        }else{
            var params = {
                'export': 1,
                'admin': this.props.selectedAdmins,
                'nazione': this.props.selectedNations,
                'year': yearToFilter,
                'month': this.props.selectedDates['month'],
                'statiCodificati': stati,
                'VM': this.props.selectedVM ? this.props.selectedVM: null,
                'campiExport': campi,
                'searchExport': searchExport
            };
        }

        const queryString = new URLSearchParams();
        Object.keys(params).forEach(key => {
            const val = params[key];
            if (
                val === null ||
                val === undefined ||
                (typeof val === 'string' && val.trim() === '') ||
                (Array.isArray(val) && val.length === 0)
            ) {
                return;
            }
            if (Array.isArray(val)) {
                val.forEach(v => {
                    if (v !== null && v !== undefined && v !== '') {
                        queryString.append(`${key}[]`, v);
                    }
                });
            } else {
                queryString.append(key, val);
            }
        });

        const apiUrl = common.getTicketBackendUrl(this.state.pathname) + 'export/?' + queryString.toString();

        fetch(apiUrl, {
            method: 'GET',
            credentials: 'include'  // se serve cookie di sessione o auth
        })
            .then(response => {
                if (!response.ok) throw new Error("Network response was not ok");

                // Prendi il nome file dall'header Content-Disposition, se presente
                const disposition = response.headers.get('Content-Disposition');
                let filename = 'ticket_export.csv'; // default
                if (disposition && disposition.indexOf('filename=') !== -1) {
                    const match = disposition.match(/filename="?([^"]+)"?/);
                    if (match && match[1]) filename = match[1];
                }

                return response.blob().then(blob => ({ filename, blob }));
            })
            .then(({ filename, blob }) => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = filename;
                document.body.appendChild(a);
                a.click();
                a.remove();
                window.URL.revokeObjectURL(url);
                $("#dropdownExport").attr("disabled", false);
                $("#dropdownExport i").removeClass("fa fa-spinner fa-spin");
                $("#dropdownExport i").addClass("far fa-file-excel");
            })
            .catch(error => {
                console.error("Errore download CSV:", error);
            });
          
    }


    getCountTicketFirebird = (data = null, searchValue = null) => {
        var params = {
            'onlyCount': 1
        }
        
        if (this.props.selectedStates){
            var selectedStates = this.props.selectedStates
        }

        params = this.getDataforFilters(params)
        if(data !== null && data !== undefined){
            if (data['Table'] !== null && data['Table'] !== undefined){
                let tableData = data['Table']
                if(tableData['SearchValue']){
                    params.searchCount = tableData['SearchValue']
                }
            }
        }else{
            if (searchValue !== null) {
                params.searchCount = searchValue
            }           
        }
        var stati = []
        for (var i = 0; i < selectedStates.length; i++) {
            var single = selectedStates[i];
            stati.push(ticketCommon.codifica_stati(single))
        };

        params.statiCodificati = stati
        if(this.props.innerTable === true){
            params.searchCount = this.state.NTELA
        }
        let apiUrl = common.getTicketBackendUrl(this.state.pathname);
        common.apiCall(apiUrl + 'count/', "GET", params, true, false, "json").then(value => {
            this.setState({ tickets_number: value['data'][0]['NELEM'] })
        })   
    }

    tablePageChange = (pageChanging) => {
        const $ = window.$;
        let pagination = this.state.pagination;
        let table = $("#tickets_firebird_table").DataTable();
        let newPage = pagination.actualPage;

        if (pageChanging == 0)
            newPage = 0;
        if (pageChanging == 0 && pagination.prev == false)
            return
        else if (pageChanging == -1 && pagination.prev == false)
            return
        else if (pageChanging == 1 && pagination.next == false)
            return
        else
            newPage += pageChanging;

        table.page(newPage).draw(false);
        pagination.actualPage = newPage;
        window.history.replaceState({}, "", common.updateURLParameter("page", newPage + 1));
        this.setState({ pagination: pagination });
    }

    getDataforFilters(data){
        const $ = window.$;
        var stati = [];
        if (this.state.userInfo.userInfo.GTSFINI?.TICKET_THREAD_INTERNO === 'S' && this.state.userInfo.userInfo.GTSFINI?.SOLO_THREAD_INTERNO === 'S'){
            var selectedStates = ['taken']
        }
        var selectedStates = this.props.selectedStates
        for (var i = 0; i < selectedStates.length; i++) {
            var single = selectedStates[i];
            stati.push(ticketCommon.codifica_stati(single))
        };
        data.statiCodificati = stati

        if (this.state.cfold === 'ticket') {
            data.tipologia = this.props.selectedType
            $('#tipologieTicket').val(this.props.selectedType).trigger("change");

        }
        if (this.props.selectedAdmins !== null || this.props.selectedAdmins !== undefined || this.props.selectedAdmins !== '') {
            var admin = this.props.selectedAdmins
        } else {
            var admin = ''
        }
        if (this.props.selectedSubType !== null || this.props.selectedSubType !== undefined || this.props.selectedSubType !== '') {
            var subType = this.props.selectedSubType
        } else {
            var subType = ''
        }
        if (this.props.is_multibrand === true) {
            data.VM = this.props.selectedVM
            $('#select_vm').val(this.props.selectedVM).trigger("change");
        }

        if (this.state.userInfo.is_admin_ticket && this.state.userInfo.userInfo.GTSFINI.PORTALE_SISTER_COMPANY && !this.state.userInfo.is_admin_ticket_group) {
            data.group = this.props.selectedGroup
            $('#tipologieTicket').val(this.props.selectedGroup).trigger("change");
        }
        
        data.dates = this.props.selectedDates
        // For epta, if state contains the closed status, the year filter is mandatory, so preselect current year
        if (window.cc.csoft === 850034 && $('#yearSelect').is(':visible') && stati.includes(ticketCommon.codifica_stati('closed')) && !data.dates?.year) {
            data.dates = data.dates || {};
            data.dates.year = String(new Date().getFullYear());
            // Set the year in the date filter UI if it's not already set
            if (!window.$('#yearSelect').val()) {
                window.$('#yearSelect').val(data.dates.year).trigger('change');
            }
        }

        data.admin = admin
        data.subType = subType
        data.nazione = this.props.selectedNations
        return data
    }

    render(props) {
        return (
            <div className="tab active">
                {this.state.customTag}
                <button id="initial_load_ticket" style={{ display: "none" }}></button>
                <div>
                    <table id="tickets_firebird_table" className="table table-striped table-bordered dt-responsive nowrap styledTable" style={{ width: '100%' }}></table>
                    <div className="dataTables_wrapper dt-bootstrap4 no-footer">
                        <div className="row">
                            <div className="col-lg-5 col-sm-12 col-xs-12" id="ticketCounter" style={{'textAlign' : 'left', 'position' : 'absolute', 'paddingLeft': '0px'}} hidden>
                                {this.state.tickets_number > 0 ?
                                <div>
                                    <span className="dataTables_info" style={{ 'paddingTop': '.45em', 'marginLeft': '20px' }}>
                                        {common.getTrad("Risultati da") + " " + this.state.start + " " + common.getTrad("a") + " " + this.state.length + " " + common.getTrad("di") +  " " + this.state.tickets_number + " " + common.getTrad("voci")}
                                    </span>
                                    {this.state.userInfo.is_admin_ticket && this.state.userInfo.userInfo.GTSFINI.TICKET_EXPORT == "S" ?
                                        <span class="dropdown" style={{ 'marginLeft': '20px' }}>
                                                <button className="btn btn-sm btn-light py-0 dropdown-toggle" title={common.getTrad("Esporta in formato CSV")} id="dropdownExport" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                    <i className="far fa-file-excel"></i>
                                                    &nbsp;&nbsp;{common.getTrad("Esporta")}
                                            </button>
                                            <div class="dropdown-menu" aria-labelledby="dropdownExport">
                                                    <a class="dropdown-item" data-arg1='reduced' style={{ 'cursor': 'pointer' }} value="reduced" onClick={this.exportData}>{common.getTrad("Esportazione ridotta")}</a>
                                                    <a class="dropdown-item" data-arg1='complete' style={{ 'cursor': 'pointer' }} value="complete" onClick={this.exportData}>{common.getTrad("Esportazione completa")}</a>
                                            </div>
                                        </span>
                                    :
                                    <></>
                                    }
                                </div>
                                :
                                <div>
                                    <span className="dataTables_info" style={{ 'paddingTop': '.45em' }}>
                                        {common.getTrad("Risultati") + " " + '0' + " " + common.getTrad("di") + " " + this.state.tickets_number + " " + common.getTrad("voci")}
                                    </span>
                                </div>

                                }
                            </div>

                            <div className="col-12 pt-4">
                                <div className="dataTables_paginate paging_full_numbers" id="tickets_firebird_table_paginate">
                                    <ul className="pagination">
                                        <li onClick={() => { this.tablePageChange(0) }}
                                            className={(!this.state.pagination.prev ? "disabled" : "") + " paginate_button page-item first"}
                                            title={common.getTrad("Inizio")}>
                                            <p className="page-link"><i className="fas fa-fast-backward"></i></p>
                                        </li>
                                        <li onClick={() => { this.tablePageChange(-1) }}
                                            className={(!this.state.pagination.prev ? "disabled" : "") + " paginate_button page-item previous"} id="table_DefaultTable_previous"
                                            title={common.getTrad("Precedente")}>
                                            <p className="page-link"><i className="fas fa-step-backward"></i></p>
                                        </li>
                                        <li onClick={() => { this.tablePageChange(1) }}
                                            className={(!this.state.pagination.next ? "disabled" : "") + " paginate_button page-item next"} id="table_DefaultTable_next"
                                            title={common.getTrad("Successivo")}>
                                            <p className="page-link" ><i className="fas fa-step-forward"></i></p>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

function getSubTypeName(CSCAU){
    if (CSCAU === 'all_brands_products')
        return 'All Other Brands & Products'
    else if (CSCAU === 'iarp')
        return 'Iarp'
    else if (CSCAU === 'eurocryor')
        return 'Eurocryor'
    else if (CSCAU === 'viessmann')
        return 'Viessmann'
    else if (CSCAU === 'george_barker')
        return "George Barker"
    else if (CSCAU === 'kysor_warren')
        return "Kysor Warren"
}

function delay(callback, ms) {
    var timer = 0;
    return function () {
        var context = this, args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
            callback.apply(context, args);
        }, ms || 0);
    };
}

function fastCopy(e, elem) {
    var $ = window.$;
    e = e || window.event;
    e.preventDefault();
    var $icon = $(elem).find("i");
    var originalClass = $icon.attr("class");
    var originalColor = $icon.css("color");
    $icon.attr("class", "fas fa-check");
    $icon.css("color", "green");
    navigator.clipboard.writeText($(elem).text().trim());
    window.setTimeout(() => {
        $icon.attr("class", originalClass);
        $icon.css("color", originalColor);
    }, 1000);

    return false;
}

export default TicketTableFirebird;
